var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F4CF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51571 13V8.24098H10.4928V13H9.51571ZM10.0043 7.54432C9.69214 7.54432 9.43881 7.29551 9.43881 6.98789C9.43881 6.67575 9.69214 6.42694 10.0043 6.42694C10.3209 6.42694 10.5743 6.67575 10.5743 6.98789C10.5743 7.29551 10.3209 7.54432 10.0043 7.54432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d6e97fe374c9305b5150fedf528f7cfb.svg";
export { ForwardRef as ReactComponent };